import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { DevicesThGroupsV2Data, ThGroup } from 'src/app/model/api/data-rest';
import { Site } from 'src/app/model/site';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import * as DeviceThActions from 'src/app/store/device-th/device-th.actions';
import { selectLoadingThGroups, selectSavingThGroups, selectThGroupsListV2 } from 'src/app/store/device-th/device-th.selector';
import { Observable, Subscription } from 'rxjs';
import { selectSites } from 'src/app/store/site/site.selector';
import { User } from 'src/app/model/user';
import { selectIsImpersMode, selectUser } from 'src/app/store/user/user.selector';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';

@Component({
	templateUrl: './manage-groups.dialog.component.html',
})

export class ManageThGroupsDialogComponent implements OnInit, OnDestroy {
	currentSite: Site;
	thOwnedGroups: ThGroup[];
	thGroupsList: DevicesThGroupsV2Data;
	thGroupsList$: Observable<DevicesThGroupsV2Data | undefined>;
	thGroupsListSub: Subscription | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	loadingThGroups: boolean = false;
	loadingThGroups$: Observable<boolean | undefined>;
	loadingThGroupsSub: Subscription | undefined;

	savingThGroups: boolean = false;
	savingThGroups$: Observable<boolean | undefined>;
	savingThGroupsSub: Subscription | undefined;

	sites: Site[];
	sites$: Observable<Site[] | undefined>;
	sitesSub: Subscription | undefined;

	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	isImpersMode: boolean;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		private translate: TranslateService,
		public confirmationService: ConfirmationService,
		public config: DynamicDialogConfig,
	) {
		this.currentSite = config.data.currentSite;
		this.thOwnedGroups = config.data.thOwnedGroups;
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.onResize();
		setTimeout(() => {
			this.store.dispatch(AnalyticsActions.eventNewAction({ eventName: 'open_manage_thgroups_site', params: { page_title: 'List Device | TH' } }));
		}, 2000);
	}

	initSelectors(): void {
		// Store selectors
		this.thGroupsList$ = this.store.select(selectThGroupsListV2);
		this.loadingThGroups$ = this.store.select(selectLoadingThGroups);
		this.savingThGroups$ = this.store.select(selectSavingThGroups);
		this.sites$ = this.store.select(selectSites);
		this.currentUser$ = this.store.select(selectUser);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
	}

	subscribeAll(): void {
		this.thGroupsListSub = this.thGroupsList$.subscribe(
			(thGroupsList) => {
				this.thGroupsList = thGroupsList;
				this.checkThGroups();
			}
		);
		this.loadingThGroupsSub = this.loadingThGroups$.subscribe(
			(loadingThGroups) => {
				this.loadingThGroups = loadingThGroups;
			}
		);
		this.savingThGroupsSub = this.savingThGroups$.subscribe(
			(savingThGroups) => {
				this.savingThGroups = savingThGroups;
				if (!savingThGroups) {
					this.getDevicesThListV2();
				}
			}
		);
		this.sitesSub = this.sites$.subscribe(
			(sites) => {
				this.sites = sites;
			}
		);
		this.currentUserSub = this.currentUser$?.subscribe(
			(currentUser) => {
				this.currentUser = currentUser;
			}
		);
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
	}

	getDevicesThListV2() {
		if (this.currentUser !== undefined) {
			if (this.isImpersMode) {
				this.store.dispatch(DeviceThActions.getDevicesThListV2({ userId: this.currentUser.Id }));
			} else {
				this.store.dispatch(DeviceThActions.getDevicesThListV2({}));
			}
		}
	}

	ngOnDestroy(): void {
		this.loadingThGroupsSub?.unsubscribe();
		this.savingThGroupsSub?.unsubscribe();
		this.currentUserSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
	}

	getAssociatedSiteName(groupSiteId: number): string {
	return groupSiteId === -1
		? '-'
		: this.sites.find(s => s.Id === groupSiteId)?.Name ?? '-';
	}

	checkThGroups(): void {
		this.thOwnedGroups = this.thGroupsList?.content.ownedGroups;
		// this.thSharedGroups = this.thGroupsList?.content.sharedGroups;
	}

	assigned(group: ThGroup): boolean {
		const groupSiteId : number = group.siteId ? group.siteId : -1;
		const siteId : number = this.currentSite.Id;
		return groupSiteId === siteId;
	}

	// canChange(): boolean {
	// 	// return (!this.assigned(site) || this.associatedToCurrentTechnician(site)) && !this.anyOpenTicketOn(site);
	// 	return true;
	// }

	// anyOpenTicketOn(site: Site): boolean {
	// 	return this.tickets.some(t => t.SiteId === site.Id && t.FlagClosed === false);
	// }

	onCheckChange(checked: boolean, group: ThGroup): void {
		if (checked) {
			this.acceptButtonStyle = "p-button-primary";
			this.rejectButtonStyle = "p-button-secondary";
			this.confirmationService.confirm({
				header: this.translate.instant('CONFIRM_ASSOCIATION'),
				message: this.translate.instant('CONFIRM_ASSOCIATE_HOUSE_SITE'),
				acceptLabel: this.translate.instant('CONFIRM'),
				rejectLabel: this.translate.instant('CANCEL'),
				icon: 'pi cm-termo',
				accept: () => {
					if (this.isImpersMode) {
						this.store.dispatch(DeviceThActions.setGroupSiteAssociation({ siteId: this.currentSite.Id, groupId: group._id, userId: this.currentUser.Id }));
					} else {
						this.store.dispatch(DeviceThActions.setGroupSiteAssociation({ siteId: this.currentSite.Id, groupId: group._id }));
					}
				},
				reject: () => {
					// refresh checkbox (not checked more)
					this.getDevicesThListV2();
				}
			});
		}
	}

	// associatedToCurrentTechnician(site: Site): boolean {
	// 	return site.TechnicianId === this.technician.Id;
	// }

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	col4ResponsiveStd(): string {
		return StandardPageLayout.col4ResponsiveStd(this.screenWidth);
	}
}
